import { TYPE_BEAT_ENUM, TYPE_BEAT_EVENT_ENUM, TYPE_RHYTHM_EVENT_ENUM } from '@/shared/config';

export enum TBeatHrActiveTab {
  'ARTIFACT',
  'N',
  'S',
  'V',
  'qToQ',
  'qToNSV',
  'hr-summary',
}

export type KeyRecoilProps = { keyRecoil: string };

export enum TPickDateAction {
  START = 'START',
  END = 'END',
  BOOKMARK = 'BOOKMARK',
  NONE = '',
}

export interface IControlModal {
  isShowIncludedStrips?: boolean;
  isShowChangeDurationButtonType?: boolean;
  isShowChangeDurationSelectedInfo?: boolean;
  isShowAddNewEvent?: boolean;
  isShowNewEvents?: boolean;
  isShowChangeTypeBulk?: boolean;
  isShowChangeTypeSingle?: boolean;
  isShowChangeAfibAvgHr?: boolean;
  isShowChangeDailyAfibHr?: boolean;
  isShowAddEcgBookmark?: boolean;
}

export type TAiChannel = 1 | 2 | 3;

export interface IDrawWidget {
  channelIndex: 0 | 1 | 2;
  startTime: string;
  endTime: string;
  type: string | 'SampleMark';
}

export interface IEventOther {
  start: string;
  stop: string;
  type: 'OTHERS';
  technicianComments?: string;
  stripImgs?: string[];
  title: string;
  draw?: IDrawWidget[];
}

export interface IEvent {
  id: number;
  idEvent: string;
  start: string;
  stop: string;
  startTimeEpoch: number; // start of minute of event start
  channel: 1 | 2 | 3;
  duration: string;
  type: TYPE_RHYTHM_EVENT_ENUM | TYPE_BEAT_EVENT_ENUM;
  avgHr?: number | null;
  maxHr?: number | null;
  minHr?: number | null;
  draw?: IDrawWidget[];
  isReviewed?: boolean;
  oldReviewed?: boolean;
  oldType?: TYPE_RHYTHM_EVENT_ENUM | TYPE_BEAT_EVENT_ENUM;
  stripImgs?: string[];
  isSaving?: boolean;
  isUpdateImage?: boolean;
  technicianComments?: string;

  linkEvents?: Array<IEvent>;
  isNew?: boolean; //* detect new event
  isChanged?: boolean; //* detect changed event
  index?: number; //* when select point from hr chart event will be given index of column show on hr chart
  startIndex?: number;
  stopIndex?: number;
  [key: string]: any;
  originalData: IEvent;
}

export interface IBeat {
  id: number;
  channel: 1 | 2 | 3;
  type: TYPE_BEAT_ENUM;
  [key: string]: any;
}

export interface IBeatChange {
  id: number;
  oldType: TYPE_BEAT_ENUM;
  type: TYPE_BEAT_ENUM;
  isLocalBeat?: boolean;
  isSaving: boolean;
}

export interface IPoint {
  index: number;
  id: number;
  startTimeEpoch: number;
  maxHr: number;
  minHr: number;
  avgHr: number;
}

export interface IDailyCount {
  date: string;
  count: number;
}

export interface IPageIndex {
  index: number;
}

export interface IReportInfo {
  studyId: string;
  profileId: string;
  facilityId: string;
  reportId: string;
  reportFid: number;
  isAbortedStudy: boolean;
  studyFid: number;
  patientName: string;
  facilityName: string;
  reportType: string;
  timezone: string;
  startReport: string;
  stopReport: string;
  timezoneOffset: number;
}

export const SIZE_THUMBNAIL_OPTIONS = {
  SMALL: 'Small',
  MEDIUM: 'Medium',
  LARGE: 'Large',
} as const;

export interface ISizeThumbnailConfig {
  name: (typeof SIZE_THUMBNAIL_OPTIONS)[keyof typeof SIZE_THUMBNAIL_OPTIONS];
  width: number;
  height: number;
}
export interface ISizeStripThumbnailConfig {
  name: (typeof SIZE_THUMBNAIL_OPTIONS)[keyof typeof SIZE_THUMBNAIL_OPTIONS];
  width: number;
  height: number;
  imageHeight: number;
  imageWidth: number;
}

export interface IEcgBookmark {
  id?: string;
  start: string;
  stop: string;
  center?: string;
  notes: string;
  startTimeEpoch?: number;
}
